import {DateRangeInterface} from "@tool/Pages/App/Project/Reports/reports.types";

const dateRange: DateRangeInterface<Date> = {
    from: new Date(),
    to: new Date(),
}

export default function useProjectReportsStore() {
    return {
        dateRange
    }
}